import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DateTimeFormatPipe } from 'mds-ui/app/shared/pipes/date-time-format.pipe';
import { HttpErrorHandler } from 'mds-ui/app/shared/service/http-error-handler.service';
import { environment } from 'mds-ui/environments/environment';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do'; // debug
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { catchError } from 'rxjs/operators';
import 'rxjs/Rx'; // use this line if you want to be lazy, otherwise:
import { Observable } from 'rxjs/Rx';
import { AssociateVO } from '../models/associates';
import { EmpPayrollInfoVO, HRSearchResponseVO, HRSearchVO, PayrollHrManagerSearchResponseVO,  PayrollHrManagersLocationResponse,  
    PayrollHrManagersRequest,  PayrollHrManagersResponse,  PayrollHrManagersSearchVO, PayrollHrManagersVO,PayrollHrUsersLocationsResponse
,PayrollHrUsersLocationsRequest } from '../models/payrollHrManager';
import {ApiResponse} from '../../../shared/model/apiresponse';

@Injectable()
export class PayrollHrManagerServices {
  //[x: string]: any;
    dtformat = new DateTimeFormatPipe("en-US");
    public index : number;
    public locationName : string;
    public locationCode : number;
    public type : string;
    public payrollHrManagersSearchVO: PayrollHrManagersSearchVO;
    public  hrSearchVO: HRSearchVO;    
    public payrollHrManagerSearchResponseVO: PayrollHrManagerSearchResponseVO;
    handleError: any; 
    payrollHrManagersVOList: PayrollHrManagersVO[];    
    payrollHrManagersVO: PayrollHrManagersVO;
    constructor(private _http: HttpClient, private httpErrorHandler: HttpErrorHandler) {
        this.handleError = httpErrorHandler.createHandleError('ProfileService');
    }
    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            "Cache-Control": "no-cache",
            Pragma: "no-cache"
        })
    };
    // getPayrollHrManagersCount(payrollHrManagersSearchVO: PayrollHrManagersSearchVO): Observable< PayrollHrManagerSearchResponseVO[]> {
    //     return this._http.post< PayrollHrManagerSearchResponseVO[]>(
    //         environment.getPayrollHrManagersCountUrl, payrollHrManagersSearchVO, this.httpOptions)
    //         .pipe(
    //             catchError(this.handleError('getPayrollHrManagersCount', []))
    //         );
    // }
    getPayrollHrManagers(payrollHrManagersSearchVO: PayrollHrManagersSearchVO): Observable< PayrollHrManagerSearchResponseVO[]> {
        return this._http.post< PayrollHrManagerSearchResponseVO[]>(
            environment.getPayrollHrManagersUrl, payrollHrManagersSearchVO, this.httpOptions)
            .pipe(catchError(this.handleError('getPayrollHrManagers', []))
            );
    }
    getPayrollHrManagersByLocationCode(locationCode: number, type: string, userName: string): Observable<PayrollHrManagersVO> {
        return this._http.get<any>(
            environment.getPayrollHrManagersByLocationCodeUrl + locationCode +"/type/"+type+ "?userName=" + userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('getPayrollHrManagersByLocationCode', []))
            );
    }
    getAssociates(associateName: string, userName: string): Observable<AssociateVO> {
        return this._http.get<any>(
            environment.getAssociatesUrl+"?associateName="+ associateName + "&userName=" + userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('getAssociates', []))
            );
    }
    postLocationManagersInfo(payrollHrManagersRequest: PayrollHrManagersRequest): Observable<PayrollHrManagersResponse> {
        return this._http.post<PayrollHrManagersResponse>(environment.postLocationManagersInfoUrl, payrollHrManagersRequest, this.httpOptions).pipe(
            catchError(this.handleError('postLocaationManagersInfo()', [])));
    }
    getEmpPyrollInfoByPersionId(personId: number, userName: string): Observable<EmpPayrollInfoVO> {
        return this._http.get<any>(
            environment.getEmpPyrollInfoByPersionIdUrl + personId + "?userName=" + userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('getEmpPyrollInfoByPersionId', []))
            );
    }
    
    exportLocationManageresInfo(payrollHrManagersSearchVO: PayrollHrManagersSearchVO): Observable<PayrollHrManagersResponse[]> {
        return this._http.post<PayrollHrManagersResponse[]>(environment.exportLocationManageresInfo , payrollHrManagersSearchVO, this.httpOptions).pipe(
            catchError(this.handleError('exportLocationManageresInfo()', [])));
    }
    getHrPersonsCount(search: HRSearchVO): Observable<HRSearchResponseVO[]> {
        return this._http.post<HRSearchResponseVO[]>(environment.getHrPersonsCount, search, this.httpOptions).pipe(
            catchError(this.handleError('getHrPersonsCount()', [])));
    }
    getHrPersons(search: HRSearchVO): Observable<HRSearchResponseVO[]> {
        return this._http.post<HRSearchResponseVO[]>(environment.getHrPersons, search, this.httpOptions).pipe(
            catchError(this.handleError('getHrPersons()', [])));
    }
    getlocationsByEmailandProfileName(email: String,profileName: String): Observable<PayrollHrManagersLocationResponse> {
        return this._http.get<PayrollHrManagersLocationResponse>(environment.getlocationsforHRLoginByMail+email+"/profile/"+profileName, this.httpOptions).pipe(
            catchError(this.handleError('getlocationsByEmailandProfileName()', [])));
    }
    getManagersByPersonIdandLocatioCode(id: number, pid: number ,username: string): Observable<PayrollHrManagersLocationResponse> {
        return this._http.get<PayrollHrManagersLocationResponse>(environment.getManagersByPersonIdandLocatioCodeURL+id+"/person/" + pid+ "?username=" + username, this.httpOptions).pipe(
            catchError(this.handleError('getManagersByPersonIdandLocatioCode()', [])));
    }
    getManagersByPersonIdAndLocationCodeAndType(id: number, pid: number ,type: string, username: string): Observable<PayrollHrManagersLocationResponse> { 
        return this._http.get<PayrollHrManagersLocationResponse>(environment.getManagersByPersonIdAndLocationCodeAndTypeURL+id+"/person/" + pid+ "/type/" + type+"?userName=" + username, this.httpOptions).pipe(
            catchError(this.handleError('getManagersByPersonIdAndLocationCodeAndType()', [])));
    }
    // getHrOrganizationList(organizationSearch: OrganizationSearch): Observable<OrganizationResponse[]> {
    //     return this._http.post<OrganizationResponse[]>(
    //         environment.getHrOrganizationsListUrl, organizationSearch, this.httpOptions)
    //         .pipe(catchError(this.handleError('getHrOrganizationList', [])));
    // }
    getEmpPayrollLocationByPersonId(pid: number, username: string): Observable<EmpPayrollInfoVO> {
        return this._http.get<any>(
            environment.getEmpPayrollLocationByPersonIdUrl + pid + "?username=" + username, this.httpOptions)
            .pipe(
                catchError(this.handleError('getEmpPayrollLocationByPersonId', []))
            );
    }
    getPayrollHrLocationsByPersonId(pid: number, username: string): Observable<PayrollHrUsersLocationsResponse> {
        return this._http.get<any>(
            environment.getPayrollHrLocationsByPersonIdUrl + pid + "?userName=" + username, this.httpOptions)
            .pipe(
                catchError(this.handleError('getPayrollHrLocationsByPersonId', []))
            );
    }

    updatePayrollHrUsersLocations(payrollHrUsersLocationsRequest : PayrollHrUsersLocationsRequest): Observable< ApiResponse[]> {
        return this._http.put< ApiResponse[]>(
            environment.updatePayrollHrUsersLocationsUrl, payrollHrUsersLocationsRequest, this.httpOptions)
            .pipe(catchError(this.handleError('updatePayrollHrUsersLocations', []))
            );
    }

    deleteNonEmployeeCCCById(id: number, userName: string): Observable<PayrollHrManagersVO> {
        return this._http.delete<any>(
            environment.deleteNonEmployeeCCCByIdUrl + id + "?userName=" + userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('deleteNonEmployeeCCCById', []))
            );
    }
    getManagersByPersonIdAndType( pid: number ,type: string, username: string): Observable<PayrollHrManagersResponse> { 
        return this._http.get<PayrollHrManagersResponse>(environment.getManagersByPersonIdAndTypeURL+ pid+ "/type/" + type+"?userName=" + username, this.httpOptions).pipe(
            catchError(this.handleError('getManagersByPersonIdAndLocationCodeAndType()', [])));
    }
    getPayrollHrManagersByPersonIdWithRelatedToCCCLocations(pid: number, userName: string): Observable<any> {
        return this._http.get<any>(
            environment.getPayrollHrManagersByPersonIdWithRelatedToCCCLocationsUrl + pid + "/ccc-locations?userName=" + userName, this.httpOptions)
            .pipe(
                catchError(this.handleError('getPayrollHrManagersByPersonIdWithRelatedToCCCLocations', []))
            );
    }
}